module.exports = __webpack_public_path__ + "img/9791197120558.f1c4ad61.jpg";